import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const HealthDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Kesehatan", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Kesehatan",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className=" tw-rounded-lg card-body">
          <div className="tw-text-accent-primary tw-text-xs">Tanggal</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>
          <div className="tw-text-accent-primary tw-text-xs">Pemeriksa</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.pemeriksa ? state.pemeriksa : "---"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Keluhan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.keluhan ? state.keluhan : "---"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">
            Obat yang diberikan
          </div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.obat ? state.obat : "---"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Status</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.keparahan ? state.keparahan : "---"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Catatan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.catatan ? state.catatan : "---"}
          </div>
        </div>
      </div>
    </>
  );
};
